import React, { useRef, useEffect, useState, useCallback } from 'react'
import gsap from 'gsap'

//* HOC's
import { withUIContext } from 'context'

//* Style
import HeroSectionStyle from './style'

//* Components
import Text from 'components/common/Text'
import Icon from 'components/common/Icon'
import LottieAnimation from 'components/common/LottieAnimation'
import Image from 'components/common/Image'
import AnimationWrap from 'components/common/AnimationWrap'

//* Lottie
import slotMachineHome from 'lottieAnimation/slotMachineHome.json'

//* Helpers
import { scaleAnimation, slideDown, slideDownAbsolute } from 'helpers/_gsapFunctions'

const HeroSection = ({ winWidth, globalData, videoFirst, videoSecond }) => {
	//! States
	const [secObj, setSecObj] = useState()

	//! Refs
	const crownIconRef = useRef()
	const crownWrapRef = useRef()
	const items = useRef([])
	const circleYoutube = useRef()
	const mainTitleFirstPartRef = useRef()
	const mainTitleSecondPartRef = useRef()
	const slotMachineRef = useRef()
	const firstVideoLayer = useRef()
	const secondVideoLayer = useRef()

	const getMouse = (e) => {
		if (winWidth >= 1024 && e.clientX) {
			if (e.clientX < Math.ceil(winWidth / 2)) {
				gsap.to(crownIconRef.current, { rotation: e.clientX * 0.01 })
			} else {
				gsap.to(crownIconRef.current, { rotation: e.clientX * -0.01 })
			}
		}
	}

	useEffect(() => {
		if (items?.current) {
			setSecObj([items.current])
		}
	}, [items, winWidth])

	const startAnimeArr = useCallback((x) => {
		if (x) {
			//! scaleAnimation(item, delay)
			scaleAnimation(circleYoutube.current, 1.2)
			scaleAnimation(crownWrapRef.current, 0.5)
			//! slideDown(item, stagger, delay)
			slideDown([mainTitleFirstPartRef.current, mainTitleSecondPartRef.current], 0.3)
			slideDown([slotMachineRef.current], null, 0.8)
			//! slideDownAbsolute(item, stagger, delay)
			slideDownAbsolute([secondVideoLayer.current, firstVideoLayer.current], 0.2, 0.8)
		}
	}, [])

	useEffect(() => {
		window.addEventListener('mousemove', getMouse)

		winWidth < 1024 && window.removeEventListener('mousemove', getMouse)

		return () => {
			window.removeEventListener('mousemove', getMouse)
		}
	}, [winWidth])

	return (
		<HeroSectionStyle>
			<AnimationWrap state={secObj} startAnimeArr={startAnimeArr}>
				<div ref={items}>
					<div className='FlexBox firstLineWrap'>
						<div className='mainTitle'>
							<div className='relativeWrap'>
								<span className='crownWrap scaleBeforeAnim' ref={crownWrapRef}>
									<svg className={'icon-crown'} ref={crownIconRef} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 169.81 93.43'>
										<g id='Layer_2' data-name='Layer 2'>
											<g id='Layer_1-2' data-name='Layer 1'>
												<g id='Path_56034' data-name='Path 56034'>
													<path d='M81.52,93.43c-29.16,0-57-2.66-57.28-2.69a1.49,1.49,0,0,1-1.26-1L.1,29a1.48,1.48,0,0,1,1-2A44.67,44.67,0,0,1,15.7,25.18a71.43,71.43,0,0,1,16.58,3.41,1.52,1.52,0,0,1,1,1.51l0,.24c0,.23,0,.45,0,.68a15,15,0,0,0,3.22,9.16A14.88,14.88,0,0,0,59.8,21.69a1.49,1.49,0,0,1,.44-2.24,102.18,102.18,0,0,0,13-8.67A83.65,83.65,0,0,0,83.59.53,1.49,1.49,0,0,1,84.7,0a1.6,1.6,0,0,1,1.13.48A122.6,122.6,0,0,0,97.66,11.55a76.19,76.19,0,0,0,11.77,7.58,1.49,1.49,0,0,1,.77,1,1.45,1.45,0,0,1-.28,1.24,14.89,14.89,0,0,0,16.3,23.3c5.58-1.79,8.52-8.71,8.84-9.86a1.48,1.48,0,0,1,1.38-1.28,1.5,1.5,0,0,1,1.6,1.39c.06,1-3.4,10.2-10.91,12.61A17.89,17.89,0,0,1,106.54,21a80.35,80.35,0,0,1-10.76-7.1,124.38,124.38,0,0,1-11-10.16,86.8,86.8,0,0,1-9.69,9.39,104.94,104.94,0,0,1-11.94,8.11,17.88,17.88,0,1,1-32.9,9.86,68.08,68.08,0,0,0-14.75-2.91,41.23,41.23,0,0,0-12,1.32l22,58.34c5.25.48,31.92,2.75,58.93,2.58s55.27-2.79,60.7-3.33l21.23-58.56a52.07,52.07,0,0,0-10.4-1.2,38.87,38.87,0,0,0-8.38,1,1.51,1.51,0,0,1-1.76-1.18A1.49,1.49,0,0,1,147,25.38a41.86,41.86,0,0,1,9-1.05A54.76,54.76,0,0,1,168.68,26a1.46,1.46,0,0,1,.95.75,1.5,1.5,0,0,1,.09,1.21L147.59,89a1.5,1.5,0,0,1-1.26,1c-.31,0-31.75,3.25-61.92,3.43Z' />
												</g>
											</g>
										</g>
									</svg>
								</span>
								<div className='overflowHidden'>
									<Text
										ref={mainTitleFirstPartRef}
										tag={'h2'}
										className='animStartPos terminaMedium relativeWrap cream titleFirstLine'
									>
										Welcome to
									</Text>
								</div>
							</div>
							<div className='overflowHidden'>
								<Text
									ref={mainTitleSecondPartRef}
									tag={'h1'}
									className='animStartPos terminaSemiBold orange FlexBox justifyEnd'
									text='ngSlot'
								/>
							</div>
						</div>
						<div className='firstVideoWrap'>
							<div ref={firstVideoLayer} className='blackLayer'></div>
							<video autoPlay loop muted playsInline className='firstVideo'>
								<source src={videoFirst} type='video/mp4' />
							</video>
						</div>
					</div>
					{winWidth < 768 && (
						<div className='secondVideoWrap secondVideoWrapMobile'>
							<div ref={secondVideoLayer} className='blackLayer'></div>
							<video autoPlay loop muted playsInline className='firstVideo mobileVideo'>
								<source src={videoSecond} type='video/mp4' />
							</video>
						</div>
					)}
					<div className='FlexBox secondLineWrap overflowHidden'>
						<div ref={slotMachineRef} className='lottieMainWrap'>
							<LottieAnimation animData={slotMachineHome} autoplay={true} isPlay={true} loop={true} />
						</div>
						{winWidth >= 768 && (
							<div className='secondVideoWrap'>
								<div ref={secondVideoLayer} className='blackLayer'></div>
								<video autoPlay loop muted playsInline className='secondVideo'>
									<source src={videoSecond} type='video/mp4' />
								</video>
							</div>
						)}
						<a
							ref={circleYoutube}
							href={globalData?.socials.youtube.link}
							target='_blank'
							className='relativeWrap subscribeWrap scaleBeforeAnim'
						>
							<Image src='/images/homeSubscribe.png' />
							<Icon className='icon-youTube' />
						</a>
					</div>
				</div>
			</AnimationWrap>
		</HeroSectionStyle>
	)
}

export default withUIContext(HeroSection, ['winWidth'])
